export default "/media/images/v.png"